import React, { useEffect, useRef, useState } from 'react'
import {
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
  Popover,
  TextField
} from '@mui/material';

import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import pt from 'date-fns/locale/pt';
import api from '../../../services/api';
import { format, endOfDay, startOfDay } from 'date-fns'
import { Button } from 'react-bootstrap';
import { classes } from './styles';
import UserPermission from '../../UserPermission';

const SelectRange = ({ setOccurrences, setRangeOccurrences, props, rangeOccurrences, refreshTrigger }) => {
  const userPermission = UserPermission();

  const maxDate = new Date(); //Hoje
  const minDate = new Date(2021, 0, 1);

  //Componente onde o popover ficará ancorado
  const [componentToShowPopover, setComponentToShowPopover] = React.useState(null);

  //Range selecionado pelo usuário
  const [ranges, setRanges] = useState({
    startDate: minDate,
    endDate: maxDate,
    key: 'selection'
  });

  //Evita empilhar requisições do poll quando a busca anterior (também de poll) ainda não terminou.
  //Ações do usuário (montagem, confirmar período) nunca são bloqueadas por esse guard.
  const isPollFetchingRef = useRef(false);

  //Utiliza o estado de ranges para atualizar o estado das ocorrências
  const updateOccurrences = async ({ isPoll = false } = {}) => {
    if (isPoll) {
      if (isPollFetchingRef.current) return;
      isPollFetchingRef.current = true;
    }

    try {
      let filter = {
        order: 'createdAt',//Necessário para o funcionamento do Grafico
      };

      if (!!ranges.startDate && !!ranges.endDate) {
        filter.where = {
          createdAt: {
            between: [
              startOfDay(ranges.startDate || minDate),
              endOfDay(ranges.endDate || maxDate)
            ]
          }
        }
      }

      const response = await api.get(`${userPermission}/complaints?filter=${JSON.stringify(filter)}`);
      setOccurrences(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      if (isPoll) isPollFetchingRef.current = false;
    }
  }

  const handleConfirm = () => {
    handleClose();
    updateOccurrences();
    setRangeOccurrences(ranges);

    //Salvar o período na sessão do navegador
    window.sessionStorage.setItem('startDate', ranges.startDate);
    window.sessionStorage.setItem('endDate', ranges.endDate);
  }

  const handleClick = (event) => {
    setComponentToShowPopover(event.currentTarget);
  };

  const handleClose = () => {
    setComponentToShowPopover(null);
  };

  useEffect(() => {
    if (rangeOccurrences.length === 0) {
      setRangeOccurrences(ranges);
    }

    updateOccurrences();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Refaz a busca das ocorrências a cada tick do poll, mantendo o período já selecionado.
  //isPoll: true faz essa chamada ceder a uma ação do usuário em andamento (handleConfirm), nunca o contrário.
  useEffect(() => {
    if (refreshTrigger) {
      updateOccurrences({ isPoll: true });
    }
  }, [refreshTrigger]); // eslint-disable-line react-hooks/exhaustive-deps

  function popOver() {
    return (
      <Popover
        id='popover-select-date'
        open={Boolean(componentToShowPopover)}
        anchorEl={componentToShowPopover}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}>
        <DateRange
          locale={pt}
          editableDateInputs={true}
          onChange={item => setRanges(item.selection)}
          moveRangeOnFirstSelection={false}
          ranges={[ranges]}
          maxDate={maxDate}
          minDate={minDate}
          dateDisplayFormat="dd MMMM yyyy"
        />

        <Box style={{ padding: 10 }}>
          <Button variant="outlined" onClick={handleConfirm}>OK</Button>
        </Box>

      </Popover>
    );
  }

  return (
    <Card
      sx={{ height: '100%' }}
      {...props}
    >
      <CardContent style={classes.first}>
        <Grid
          container
          spacing={1}
          style={classes.gridContainer}

        >
          <Grid item>
            <Typography
              className="box-title"
              gutterBottom
              variant="h6"
            >
              Selecione um período de análise
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <TextField
              fullWidth
              variant='outlined'
              size='small'
              label='Período'
              onClick={handleClick}
              value={
                format(rangeOccurrences.startDate || minDate, 'dd/MM/yyyy') +
                " até " +
                format(rangeOccurrences.endDate || maxDate, 'dd/MM/yyyy')
              }
              style={{ textAlignLast: 'center' }} />
          </Grid>

        </Grid>
      </CardContent>
      {popOver()}
    </Card>
  );
}

export default SelectRange;
